// Base URL for backend-hosted attachment images (coverings, gutters, extensions, isolation).
// Absolute on the CRA dev server (start-*, different origin than the backend), relative in
// built bundles (build-*, served by the backend itself).
const API_ORIGIN = process.env.REACT_APP_API_URL?.replace(/\/api\/v3\/?$/, '');

export const attachmentsHref = (process.env.NODE_ENV === 'development')
    ? `${API_ORIGIN}/prilohy/cenovanabidka/`
    : '../prilohy/cenovanabidka/';
